import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LeftOutlined } from '@ant-design/icons';

export default function Settings() {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: '100vh', background: '#f5f7fa', maxWidth: 750, margin: '0 auto' }}>
      <div style={{
        display: 'flex', alignItems: 'center', padding: '12px 16px',
        background: '#fff', borderBottom: '1px solid #f0f0f0',
      }}>
        <LeftOutlined onClick={() => navigate(-1)} style={{ fontSize: 18, marginRight: 12 }} />
        <span style={{ fontSize: 17, fontWeight: 600 }}>设置</span>
      </div>
      <div style={{ padding: 24, color: '#666', fontSize: 14, lineHeight: 1.8 }}>
        暂无额外系统设置项。修改密码请前往「我的」-「修改密码」。
      </div>
    </div>
  );
}
